import BaseAPI from "./BaseAPI";

// const { apiData } = require("utils/api");

class CustomerProfileAPI extends BaseAPI {
  constructor() {
    super();
    this.leadID = this.getLeadIDFromURL();
    this.customerID = this.getCustomerID();
  }

  getLeadIDFromURL() {
    const urlPath = window.location.pathname.split("/");
    return urlPath[2] || "";
  }

  // User Profile API
  async userProfileAPI(leadID) {
    const req = {
      url: `lead/profile?leadID=${leadID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Lead Status Dropdown API
  async leadStatusDropdownAPI() {
    const req = {
      url: `common/${this.leadID}/statuses`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Basic Lead Details API
  async basicLeadDetailsAPI() {
    const req = {
      url: `lead/${this.leadID}/basic-lead-details`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Change Status API
  async changeStatusAPI(values) {
    const req = {
      url: `lead/${this.leadID}/change-status`,
      method: "PUT",
      data: values,
    };

    return await this.makeRequest(req, true);
  }
  // change-status-whitelist customer API
  ChangeStatusWhitelistCustomerAPI = async (payload) => {
    const req = {
      url: `lead/change-status-whitelist`,
      method: "PUT",
      data: payload,
    };
    return await this.makeRequest(req, true);
  };

  // Razorpay Disbursal Status API
  async razorpayDisbursalStatusAPI(values) {
    console.log(values, "razorpayDisbursalStatusAPI");

    const req = {
      url: `lead/${this.leadID}/razorpay-disbursal`,
      method: "POST",
      data: values,
    };
    return await this.makeRequest(req, true);
  }
  // Disbursal Update  Status API
  async disbursalUpdateStatusAPI(values) {
    const req = {
      url: `lead/${this.leadID}/disbursal-update`,
      method: "POST",
      data: values,
    };
    return await this.makeRequest(req, true);
  }
  // Razorpay Disbursal Status fetch API
  async razorpayDisbursalAPI() {
    const req = {
      url: `lead/${this.leadID}/razorpay-disbursal`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  async changeApprovedProcessStatusAPI(values) {
    const req = {
      url: `lead/${this.leadID}/change-status`,
      method: "PUT",
      data: values,
    };

    return await this.makeRequest(req, true);
  }

  async emiCalculatorAPI(values) {
    const { loanAmtApproved, roi, tenure, repaymentDate } = values;

    const req = {
      url: `crm/emiCalculator?loanAmount=${loanAmtApproved}&roi=${roi}&tenure=${tenure}&firstRepayDate=${repaymentDate}`,
      method: "GET",
      data: "",
    };

    return await this.makeRequest(req);
  }

  // Employment Details API
  async employmentDetailsAPI() {
    const req = {
      url: `lead/${this.leadID}/employement-details`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Employment Details API
  async loanApplyStatusAPI() {
    const req = {
      url: `lead/${this.leadID}/loan-apply-status`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Address Details API
  async addressDetailsAPI() {
    const req = {
      url: `lead/${this.leadID}/address`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  //Add Address
  async addAddress(data) {
    const req = {
      url: `history/add-address`,
      method: "POST",
      data: {
        customerID: this.customerID,
        leadID: this.leadID,
        type: data.type,
        address: data.address,
        city: data.city,
        isVerified: data.isVerified,
        state: data.state,
        pincode: Number(data.pincode),
      },
    };
    if (data.region) req.data.region = data.region;
    return await this.makeRequest(req, true);
  }

  // Change Address Details API
  async changeAddressDetailsAPI(values) {
    const req = {
      url: `lead/${this.leadID}/change-address-details`,
      method: "POST",
      data: {
        address: values.address,
        city: values.city,
        pincode: values.pincode,
        state: values.state,
      },
    };
    return await this.makeRequest(req, true);
  }

  // Check Pincode API
  async checkPincodeAPI(code) {
    const req = {
      url: `lead/checkPincode?pincode=${code}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // References Details API
  async referencesDetailsAPI() {
    const req = {
      url: `lead/${this.leadID}/references`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // References Details API
  async addReferencesAPI(values) {
    const req = {
      url: `lead/add-reference`,
      method: "POST",
      data: {
        name: values.name,
        mobileNo: values.phone,
        relation: values.relation,
        leadID: this.leadID,
      },
    };
    return await this.makeRequest(req, true);
  }

  // Loan Details API
  async creditDetailsAPI() {
    const req = {
      url: `lead/credit-detail?leadID=${this.leadID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }
  // Loan Details API
  async loanDetailsAPI() {
    const req = {
      url: `lead/${this.leadID}/loan-details`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Modify EMI Loan API
  async modifyEMILoanAPI(values) {
    const req = {
      url: `lead/${this.leadID}/modify-emi-loan`,
      method: "PUT",
      data: {
        adminFee: Number(values.adminFee),
        loanAmount: Number(values.loanAmount),
        repaymentDate: values.repaymentDate,
        roi: Number(values.roi),
        tenure: Number(values.tenure),
      },
    };
    return await this.makeRequest(req, true);
  }

  // Modify Payday Loan API
  async modifyPaydayLoanAPI(values) {
    const req = {
      url: `lead/${this.leadID}/modify-payday-loan`,
      method: "PUT",
      data: {
        adminFee: Number(values.adminFee),
        loanAmount: Number(values.loanAmount),
        repaymentDate: values.repaymentDate,
        roi: Number(values.roi),
      },
    };
    return await this.makeRequest(req, true);
  }

  // EMI Schedule API
  async emiScheduleAPI() {
    const req = {
      url: `lead/emi-crmData?leadID=${this.leadID}&customerID=${this.customerID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Panny Drop API
  async pennyDropAPI() {
    const req = {
      url: `lead/${this.leadID}/penny-drops`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // ckeck panny drop

  async checkPannyDropAPI(data) {
    const req = {
      url: `lead/check-penny-drop`,
      method: "POST",
      data: {
        leadID: Number(this.leadID),
        accountNo: Number(data?.account),
      },
    };
    return await this.makeRequest(req);
  }

  // Emandate Details API
  async emandateDetailsAPI() {
    const req = {
      url: `lead/${this.leadID}/emandates`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Update Employment Details API
  async updateEmploymentDetailsAPI(values) {
    const req = {
      url: `lead/${this.leadID}/create-employement-details`,
      method: "POST",
      data: {
        designation: values.designation,
        employerID: values.employerID,
        income: values.income,
        industry: values.industry,
        officeAddress: values.address,
        officialEmailId: values.officialEmail,
        salaryMode: values.salaryMode,
        totalExperience: values.experience,
      },
    };
    return await this.makeRequest(req, true);
  }

  // Disable Emandate API
  async disableEmandateAPI() {
    const req = {
      url: `lead/${this.leadID}/disable-emandate`,
      method: "PATCH",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Get Bank Account API
  async getBankAccountAPI() {
    const req = {
      url: `lead/${this.leadID}/bank-account`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Lead Approved Details API
  async leadApprovedDetailsAPI() {
    const req = {
      url: `lead/${this.leadID}/approval-details`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Generate Emandate API
  async genrateEmandateAPI(accountID) {
    const req = {
      url: `lead/${this.leadID}/generate-emandate`,
      method: "POST",
      data: {
        accountID,
      },
    };
    return await this.makeRequest(req);
  }

  // Charge Emandate API
  async chargeEmandateAPI(values, emandateID) {
    const req = {
      url: `lead/${this.leadID}/create-charge`,
      method: "POST",
      data: {
        emandateAmount: values.amount,
        emandateID: emandateID,
        remark: values.remarks,
      },
    };
    return await this.makeRequest(req);
  }

  // Collection Details API
  async collectionDetailsAPI() {
    const req = {
      url: `lead/${this.leadID}/collection-details`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Add Payday Collection Details API
  async addCollectionPaydayAPI(values) {
    const req = {
      url: `lead/${this.leadID}/add-collection-details`,
      method: "POST",
      data: {
        cooling_period: values.cooling_period,
        collectedAmount: values.collectedAmount,
        status: values.status,
        collectedMode: values.collectedMode,
        collectedDate: values.collectedDate,
        referenceNo: values.referenceNo.trim(),
        discount_waiver: values.discount_waiver,
        discount_waiver_amount: values.discount_waiver_amount,
      },
    };
    return await this.makeRequest(req);
  }

  //  Update Payment Mode Collection Details
  async updateCollectionPaymentMode(data) {
    const req = {
      url: `lead/collection-update-mode`,
      method: "PUT",
      data: data,
    };
    return await this.makeRequest(req);
  }

  //  Add Refund Amount API
  async addCollectionRefundAmountAPI(values, id) {
    const req = {
      url: `lead/lead-refund-update`,
      method: "POST",
      data: {
        collectionID: id,
        leadID: this.leadID,
        refundDate: values.refundDate,
        utrNo: values.utrNo,
        status: values.leadStatus,
        remark: values.remark,
        prAmount: values.amount,
      },
    };
    return await this.makeRequest(req);
  }

  // Add EMI Collection Details API
  async addEMICollectionDetailsAPI(values) {
    const req = {
      url: `lead/${this.leadID}/add-emi-collection-details`,
      method: "POST",
      data: {
        collectedAmount: values.paymentAmount,
        collectedMode: values.paymentMode,
        referenceNo: values.referenceNo.trim(),
        collectedDate: values.paymentDate,
        status: values.paymentAction,
        remarks: values.remarks,
        waiver: values.discountAmount,
        discount_type: values.discountType,
      },
    };
    return await this.makeRequest(req);
  }

  // Download Collection CSV API
  async downloadCollectionCSVAPI() {
    const req = {
      url: `lead/${this.leadID}/download-collection-csv`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Collection FollowUp API
  async collectionFollowUpAPI() {
    const req = {
      url: `lead/${this.leadID}/collection-follow-up?isSanction=false`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // E-Mandate Charges API
  async mandateChargeAPI(page = 1, perPage = 10) {
    const req = {
      url: `lead/${this.leadID}/emandate-charges?page=${page}&perPage=${perPage}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Virtual Account Details API
  async virtualAccountDetailsAPI() {
    const req = {
      url: `lead/${this.leadID}/virtualAccountDetails`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Generate Virtual Account API
  async generateVirtualAccountAPI() {
    const req = {
      url: `lead/${this.leadID}/virtual-account?qrCode=1`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Bank Account Details API
  async bankAccountDetailsAPI() {
    const req = {
      url: `lead/${this.leadID}/bank-account-details`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Bank Account Details API
  async statementOfAccountAPI() {
    const req = {
      url: `lead/${this.customerID}/get-soa`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Download SOA EMI API
  async downloadSOAEMIAPI(leadId) {
    const req = {
      url: `lead/generate-soa`,
      method: "POST",
      data: {
        leadID: leadId,
        customerID: this.customerID,
      },
    };
    return await this.makeRequest(req, true);
  }

  // Download SOA Payday API
  async downloadSOAPaydayAPI(leadId) {
    const req = {
      url: `lead/generate-soa-payday`,
      method: "POST",
      data: {
        leadID: leadId,
        customerID: this.customerID,
      },
    };

    return await this.makeRequest(req, true);
  }
  //Name Match API
  async nameMatchAPI() {
    const req = {
      url: `doc/nameDob-match?customerID=${this.customerID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Documents API
  async documentListAPI() {
    const req = {
      url: `doc/list?leadID=${this.leadID}&customerID=${this.customerID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  //Dowmload Log Api

  async generateFraudReportAPI(data) {
    const req = {
      url: `fraud-report/generate-and-download`,
      method: "POST",
      data: data,
      responseType: "blob",
    };

    return await this.makeRequest(req);
  }

  async updatePaymentStatus(data) {
    const req = {
      url: "collection/reject-payday-payment",
      method: "POST",
      data,
    };

    return await this.makeRequest(req);
  }

  async saveAgreementAPI(leadId, customerID) {
    const req = {
      url: `soa/aggrement-pdf-email?leadID=${leadId}&customerID=${customerID}`,
      method: "GET",
    };

    return await this.makeRequest(req);
  }

  async markedLeadBankRejectAPI(leadID, customerID) {
    const req = {
      url: "lead/refresh-disbursal-status",
      method: "POST",
      data: {
        leadID,
        customerID,
      },
    };
    return await this.makeRequest(req, true);
  }

  // PDF URL API
  async pdfURLAPI(entityID, type) {
    const req = {
      url: `doc/pdf-url?entityID=${entityID}&type=${type}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Sanction Follow-up API
  async sanctionFollowUpAPI() {
    const req = {
      url: `lead/${this.leadID}/collection-follow-up?isSanction=true`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Add Sanction Follow-up API
  async addSanctionFollowUpAPI(values, type) {
    const req = {
      url: `lead/${this.leadID}/add-collection-followup`,
      method: "POST",
      data: {
        followType: values.contactType,
        StatusType: values.status,
        remark: values.remarks,
        followup_type: `${type}`,
      },
    };
    return await this.makeRequest(req);
  }

  // E-mail History API
  async emailHistoryAPI() {
    const req = {
      url: `history/email-list?customerID=${this.customerID}&leadID=${this.leadID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Send Disbursal Letter API
  async sendDisbursalLetterAPI() {
    const req = {
      url: `lead/disbursal-pdf-email?leadID=${this.leadID}&customerID=${this.customerID}`,
      method: "GET",
      data: {},
    };

    return await this.makeRequest(req);
  }
  // Send settlement Letter API
  async sendSettlementLetterAPI() {
    const req = {
      url: `lead/send-settlement-email?leadID=${this.leadID}&customerID=${this.customerID}`,
      method: "GET",
      data: {},
    };

    return await this.makeRequest(req);
  }
  // Send Sanction Letter API
  async sendSanctionLetterAPI() {
    const req = {
      url: `soa/section-pdf-email?leadID=${this.leadID}&customerID=${this.customerID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Send NOC API
  async sendNOCAPI() {
    const req = {
      url: `lead/noDues-pdf-email?leadID=${this.leadID}&customerID=${this.customerID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Loan History API
  async loanHistoryAPI() {
    const req = {
      url: `history/loan-list?customerID=${this.customerID}&leadID=${this.leadID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Lead History API
  async leadHistoryAPI() {
    const req = {
      url: `history/lead-list?customerID=${this.customerID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Address History API
  async addressHistoryAPI() {
    const req = {
      url: `history/address-list?customerID=${this.customerID}&leadID=${this.leadID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Employment History API
  async employmentHistoryAPI() {
    const req = {
      url: `history/employment-list?customerID=${this.customerID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Salary History API
  async salaryHistoryAPI() {
    const req = {
      url: `history/salary-list?customerID=${this.customerID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Location History API
  async locationHistoryAPI() {
    const req = {
      url: `history/location-list?customerID=${this.customerID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Bank Account Aggregator Links API
  async bankAccountAggregatorLinkAPI() {
    const req = {
      url: `history/account-aggregator-list?customerID=${this.customerID}`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // CRM Timeline API
  async crmTimelineAPI() {
    const req = {
      url: `lead/${this.leadID}/crm-timeline`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Get API Logs API
  async apiLogsAPI(page) {
    const req = {
      url: `customer/${this.customerID}/api-logs?page=${page}&limit=20`,
      method: "GET",
      data: {},
    };

    // console.log("req-------", req?.url);

    return await this.makeRequest(req);
  }

  // Get API Response API
  async apiResponseAPI(apiID) {
    const req = {
      url: `customer/${this.customerID}/api-log`,
      method: "POST",
      data: {
        id: apiID,
      },
    };
    return await this.makeRequest(req);
  }

  // Bank Update Check API
  async bankUpdateCheckAPI() {
    const req = {
      url: `lead/${this.leadID}/bank-update-check`,
      method: "GET",
      data: {},
    };
    return await this.makeRequest(req);
  }

  // Bank Update Check Submit API
  async bankUpdateCheckSubmitAPI(data) {
    const req = {
      url: `lead/${this.leadID}/bank-update-check`,
      method: "POST",
      data: data,
    };
    return await this.makeRequest(req, true);
  }

  // Customer API
  async CustomerAPI(qurStr) {
    const urlParams = new URLSearchParams(window.location.search);
    const req = {
      url: `customer?${urlParams.toString()}`,
      method: "GET",
      data: {},
    };

    return await this.makeRequest(req);
  }

  // Customer Update API
  async CustomerUpdateAPI(val) {
    const req = {
      url: `customer`,
      method: "PUT",
      data: val,
    };

    return await this.makeRequest(req);
  }

  // payday To Emi Loan Conversion
  async paydayToEmiConversion(payload) {
    const req = {
      url: `crm/paydayToEmiConversion`,
      method: "POST",
      data: payload,
    };
    return await this.makeRequest(req, true);
  }

  // Customer API
  CallbackRequest = async (queryString) => {
    const req = {
      url: `lead/callback-request?${queryString}`,
      method: "GET",
    };

    return await this.makeRequest(req);
  };

  // Customer API
  async EmailphoneVerifyAPI(payload, customerID) {
    const req = {
      url: `customer/${customerID}/email-phone`,
      method: "PUT",
      data: payload,
    };

    return await this.makeRequest(req);
  }

  // verify otp
  async VerifyOTPAPI(payload) {
    const req = {
      url: `customer/verify-otp`,
      method: "POST",
      data: payload,
    };

    return await this.makeRequest(req);
  }

  // Check Fraud API
  CheckFraudAPI = async (documentID) => {
    const req = {
      url: `doc/lead-finbox-check-fraud?documentID=${documentID}`,
      method: "GET",
    };

    return await this.makeRequest(req);
  };

  SendAllignVisitMailAPI = async (customerID) => {
    const req = {
      url: `lead/allign-pdf-email?leadID=${this.leadID}&customerID=${customerID}`,
      method: "GET",
    };

    return await this.makeRequest(req);
  };

  // blacklist customer add
  BlacklistCustomerAddAPI = async (payload) => {
    const req = {
      url: `lead/blacklist_customer_add`,
      method: "POST",
      data: payload,
    };
    return await this.makeRequest(req, true);
  };

  // feedbacks API
  feedbackRequest = async (queryString) => {
    const req = {
      url: `customer/feedbacks?${queryString}`,
      method: "GET",
    };

    return await this.makeRequest(req);
  };

  // Customer Data Update API
  async customerDataUpdateAPI(payload) {
    const req = {
      url: `customer-data-update/update`,
      method: "POST",
      data: {
        customerID: payload.customerID,
        changeReason: payload.changeReason,
      },
    };
    return await this.makeRequest(req, true);
  }

  fetchAccountAAReport = async (payload) => {
    const req = {
      url: "doc/account-gator/retrieve-report",
      method: "post",
      data: payload,
    };
    return await this.makeRequest(req, false);
  }
    // update aml Status API
  async updateAMLStatus(values) {
    const req = {
      url: `lead/update-aml-status?leadID=${this.leadID}`,
      method: "PUT",
      data: values,
    };

    return await this.makeRequest(req, true);
  }

  fetchQRPaymentLogs = async () => {
    const req = {
      url: `razorpay-qr/list?leadID=${this.leadID}`,
      method: "get",
    };
    return await this.makeRequest(req, false);
  };
  generateQRcode = async (payload) => {
    const req = {
      url: "razorpay-qr/generate",
      method: "post",
      data: {
        leadID: this.leadID,
        customerID: this.customerID,
        description: `qr generate for ${this.leadID}`,
        ...payload,
      },
    };
    return await this.makeRequest(req, false);
  };

  sendCommunication = async (customerId) => {
    const req = {
      url: `customer/${customerId}/send-journey-link`,
      method: "post"
    };
    return await this.makeRequest(req, false);
  };
}

export default CustomerProfileAPI;
